import React from 'react'
import { Divider, WidgetContent } from '@duik/it'
import { ModalButton } from '../UI/ModalButton'
import CloseIcon from '@material-ui/icons/ClearRounded'
import styled from '@emotion/styled'
import Widget from './Widget'

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
`

const ModalWrapper = styled.div`
  max-width: 540px;
  max-height: 226px;
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const HeadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Heading = styled.h3`
  margin: 25px;
  color: #3e3f42;
`

const Text = styled.p`
  font-size: 16px;
  color: #3e3f42;
`

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 25px;
`

const ButtonWrapper = styled.div`
  width: 83px;
`

const StyledWidget = styled(Widget)`
  width: 100%;
  height: 100%;
`

type Props = {
  heading: string
  text: string
  onCloseClick: () => void
  onOKClick: () => void
  confirmButtonType?: 'primary' | 'secondary'
  confirmName?: string
}

const SmConfirmModal = ({
  heading,
  text,
  onCloseClick,
  onOKClick,
  confirmButtonType = 'primary',
  confirmName
}: Props) => (
  <Container>
    <ModalWrapper>
      <StyledWidget>
        <HeadingWrapper>
          <Heading>{heading}</Heading>
          <CloseIcon onClick={onCloseClick} className="closeIcon" />
        </HeadingWrapper>
        <Divider />
        <WidgetContent>
          <Text>{text}</Text>
        </WidgetContent>
        <ButtonsContainer>
          <ButtonWrapper>
            <ModalButton
              name="Cancel"
              buttonStyle="tertiary"
              type="button"
              success={false}
              onClick={onCloseClick}
            />
          </ButtonWrapper>
          <ButtonWrapper>
            <ModalButton
              success={confirmButtonType === 'primary'}
              type="button"
              buttonStyle={confirmButtonType}
              onClick={onOKClick}
              name={confirmName || 'OK'}
            />
          </ButtonWrapper>
        </ButtonsContainer>
      </StyledWidget>
    </ModalWrapper>
  </Container>
)

export default SmConfirmModal
